import { combineReducers } from "redux";
import leadFormReducer from "../lead-form/reducers";

const rootReducer = combineReducers({
  leadForm: leadFormReducer,
});

export default rootReducer;
